<div *ngIf="labService.currentSelectedGadget" class="container main-component-container">

  <!--Header-->
  <div class="page-header page-header-no-margin">
    <div class="page-header-left-container page-header-filler">
      <img (click)="changeMainSlide.emit(MainSliderSection.LAB)" class="page-header-chat-icon hover-icon"
        src="../../../assets/generic/back_arrow_white.svg">
    </div>
    <div class="page-header-right-container">
      <p class="page-header-text gadget-header-text">{{ 'Gadget:' | translate }} {{labService.currentSelectedGadget.gadgetLanguage.name}}
      </p>
    </div>
    <!--Filler-->
    <div class="page-header-filler">
      <img class="page-header-icon pop-hover user-list-icon" (click)="loadGadgetUserListComponentDialog()"
        src="../../../assets/navbar/contacts.svg">
      <img
        *ngIf="labService.currentSelectedGadget?.currentGadgetUserComplete?.gadgetUser.roleId && labService.currentSelectedGadget?.currentGadgetUserComplete?.gadgetUser.roleId <= RoleEnum.ADMIN"
        class="page-header-icon pop-hover" data-tutorial-target="gadget-settings-gear" (click)="loadGadgetSettingsComponentDialog()"
        src="../../../assets/generic/settings_gear_white.svg">
    </div>
  </div>

  <div class="page-content-container page-content-container-no-top-padding">

    <div *ngIf="false" class="page-content-header-container mobile-gadget-section-nav-container">
      <p (click)="changeSelectedGadgetSection(SelectedGadgetSection.COMPONENTS)"
        [ngClass]="selectedGadgetSection != SelectedGadgetSection.COMPONENTS ? 'page-content-header-text-disabled' : ''"
        class="page-content-header-text gadget-nav-text">{{ 'Components' | translate }}</p>
      <p (click)="changeSelectedGadgetSection(SelectedGadgetSection.MEMBERS)"
        [ngClass]="selectedGadgetSection != SelectedGadgetSection.MEMBERS ? 'page-content-header-text-disabled' : ''"
        class="page-content-header-text gadget-nav-text">{{ 'Members' | translate }}</p>
      <p (click)="changeSelectedGadgetSection(SelectedGadgetSection.SETTINGS)"
        [ngClass]="selectedGadgetSection != SelectedGadgetSection.SETTINGS ? 'page-content-header-text-disabled' : ''"
        class="page-content-header-text gadget-nav-text">{{ 'Settings' | translate }}</p>

    </div>

    <div class="gadget-content-container">
      <ng-container *ngIf="selectedGadgetSection == SelectedGadgetSection.COMPONENTS">
        <div class="page-header">
          <div class="page-header-left-container">
            <p class="page-subheader-text">{{ 'Components' | translate }}</p>
          </div>
          <div class="page-header-right-container">
            <button *ngIf="!tutorialService.isCreateComponentTutorialActive && labService.currentSelectedGadget?.currentGadgetUserComplete?.gadgetUser.roleId && labService.currentSelectedGadget?.currentGadgetUserComplete?.gadgetUser.roleId <= RoleEnum.CREATOR"
              type="button" class="members-tutorial-button members-tutorial-button-header" (click)="startCreateComponentTutorial()">{{ 'Start Tutorial' | translate }}</button>
            <button
              *ngIf="labService.currentSelectedGadget?.currentGadgetUserComplete?.gadgetUser.roleId && labService.currentSelectedGadget?.currentGadgetUserComplete?.gadgetUser.roleId <= RoleEnum.CREATOR"
              class="circle-button primary-light-button" (click)="loadCreateGadgetComponentDialog()"><img src="assets/generic/plus_icon.svg"></button>
          </div>
        </div>

        <button *ngIf="!tutorialService.isCreateComponentTutorialActive && labService.currentSelectedGadget?.currentGadgetUserComplete?.gadgetUser.roleId && labService.currentSelectedGadget?.currentGadgetUserComplete?.gadgetUser.roleId <= RoleEnum.CREATOR"
          type="button" class="members-tutorial-button members-tutorial-button-mobile" (click)="startCreateComponentTutorial()">{{ 'Start Tutorial' | translate }}</button>

        <div class="flex-list-container-vertical">

          <!-- Create Component Card -->
          <div
            *ngIf="labService.currentSelectedGadget?.currentGadgetUserComplete?.gadgetUser.roleId && labService.currentSelectedGadget?.currentGadgetUserComplete?.gadgetUser.roleId <= RoleEnum.CREATOR"
            (click)="loadCreateGadgetComponentDialog()" class="flex-list-item" data-tutorial-target="gadget-create-component">
            <div class="card-container">
              <div class="create-card-background">
                <img class="create-card-plus" src="assets/generic/plus_icon.svg">
              </div>
              <div class="card-text-container">
                <p class="card-text">{{ 'Create Component' | translate }}</p>
              </div>
            </div>
          </div>

          <div *ngFor="let componentComplete of labService.currentSelectedGadget.componentsComplete"
            (click)="loadComponent(componentComplete)" class="flex-list-item">

            <div class="card-container">
              <lazy-image class="card-image"
                [src]="componentComplete.component?.curatedIconUrl || componentComplete.iconFileUploadComplete?.srcUrl || '../../assets/icon/default_component.jpg'"
                [alt]="componentComplete.componentLanguage?.name"
                [placeholder]="'../../assets/icon/default_component.jpg'"></lazy-image>

              <div *ngIf="labService.currentSelectedGadget?.currentGadgetUserComplete?.gadgetUser?.roleId <= RoleEnum.CREATOR"
                class="card-delete-btn" (click)="deleteComponent($event, componentComplete)">
                <img src="assets/svgs/solid/trash.svg" class="delete-icon">
              </div>

              <div class="card-text-container">
                <p class="card-text">{{componentComplete.componentLanguage?.name}}</p>
                <p class="card-subtext component-last-active-card-text"
                  [matTooltip]="formatAbsoluteDate(componentComplete.component?.lastValueUpdateAt)">
                  {{formatComponentLastActive(componentComplete.component?.lastValueUpdateAt)}}
                </p>
              </div>

            </div>
          </div>

        </div>
      </ng-container>

      <ng-container *ngIf="selectedGadgetSection == SelectedGadgetSection.MEMBERS">
        <p>{{gadgetComplete?.currentGadgetUserComplete?.userSafe.nickname}}</p>
        <gadget-user-list [labComplete]="labService.currentSelectedLab"></gadget-user-list>
      </ng-container>

      <ng-container *ngIf="selectedGadgetSection == SelectedGadgetSection.SETTINGS">
        <gadget-settings>

        </gadget-settings>
      </ng-container>

    </div>

  </div>

</div>